(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('BusinessType', BusinessType);

    BusinessType.$inject = ['$resource'];

    function BusinessType ($resource) {
        var resourceUrl =  'api/business-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
